/* eslint no-template-curly-in-string: 0 */
// Custom error messages
// https://joi.dev/api/?v=17.3.0#list-of-errors
const messages = {
    // 'alternatives.all': '',
    // 'alternatives.any': '',
    // 'alternatives.match': '',
    // 'alternatives.one': '',
    // 'alternatives.types': '',
    // 'any.custom': '',
    'any.default': 'Something went wrong with this field, please let us know',
    // 'any.failover': '',
    // 'any.invalid': '',
    // 'any.only': '',
    // 'any.ref': '',
    'any.required': 'This field is required',
    'any.unknown': 'Something went wrong with this field, please let us know',
    'array.base': 'This field is required',
    'array.excludes': '',
    // 'array.includesRequiredBoth': '',
    // 'array.includesRequiredKnowns': '',
    // 'array.includesRequiredUnknowns': '',
    // 'array.includes': '',
    'array.length': 'This field must have exactly {#limit} items',
    'array.max': 'This field must have no more than {#limit} items',
    'array.min': 'This field must have at least {#limit} items',
    // 'array.orderedLength': '',
    // 'array.sort': '',
    // 'array.sort.mismatching': '',
    // 'array.sort.unsupported': '',
    // 'array.sparse': '',
    // 'array.unique': '',
    // 'array.hasKnown': '',
    // 'array.hasUnknown': '',
    // 'binary.base': '',
    // 'binary.length': '',
    // 'binary.max': '',
    // 'binary.min': '',
    'boolean.base': 'This field is required',
    'date.base': 'This field is required',
    // 'date.format': '',
    'date.greater': 'This field must be later than {#limit}',
    'date.less': 'This field must be earlier than {#limit}',
    'date.max': 'This field must be at earlier than {#limit}',
    'date.min': 'This field must be later than {#limit}',
    'date.strict': '',
    // 'function.arity': '',
    // 'function.class': '',
    // 'function.maxArity': '',
    // 'function.minArity': '',
    'number.base': 'This field requires a number value',
    'number.greater': 'This field must be greater than {#limit}',
    // 'number.infinity': '',
    'number.integer': 'This field must be an integer',
    'number.less': 'This field must be less than {#limit}',
    'number.max': 'This field must be less than or equal to {#limit}',
    'number.min': 'This field must be greater than or equal to {#limit}',
    // 'number.multiple': '',
    'number.negative': 'This field must be a negative number',
    // 'number.port': '',
    'number.positive': 'This field must be a positive number',
    // 'number.precision': '',
    // 'number.unsafe': '',
    // 'object.unknown': '',
    // 'object.and': '',
    // 'object.assert': '',
    'object.base': 'This field is required',
    // 'object.length': '',
    // 'object.max': '',
    // 'object.min': '',
    // 'object.missing': '',
    // 'object.nand': '',
    // 'object.pattern.match': '',
    // 'object.refType': '',
    // 'object.regex': '',
    // 'object.rename.multiple': '',
    // 'object.rename.override': '',
    // 'object.schema': '',
    // 'object.instance': '',
    // 'object.with': '',
    // 'object.without': '',
    // 'object.xor': '',
    // 'object.oxor': '',
    // 'string.alphanum': '',
    // 'string.base64': '',
    'string.base': 'This field is required',
    // 'string.creditCard': '',
    // 'string.dataUri': '',
    // 'string.domain': '',
    'string.email': 'This field must be a valid email',
    'string.empty': 'This field is required',
    // 'string.guid': '',
    // 'string.hexAlign': '',
    // 'string.hex': '',
    // 'string.hostname': '',
    // 'string.ipVersion': '',
    // 'string.ip': '',
    // 'string.isoDate': '',
    // 'string.isoDuration': '',
    'string.length': 'This field must be exactly {#limit} characters',
    'string.lowercase': 'This field must be a lowercase string',
    'string.max': 'This field must be less than {#limit} characters',
    'string.min': 'This field must be at least {#limit} characters',
    // 'string.normalize': '',
    'string.pattern.base': 'This field must match the following: "{$pattern}"',
    'string.pattern.name': 'This field must match the following: "{$pattern}"',
    'string.pattern.invert.base':
        'This field must not match the following: "{$pattern}"',
    'string.pattern.invert.name':
        'This field must not match the following: "{$pattern}"',
    // 'string.token': '',
    'string.trim': 'This field must be a trimmed string',
    'string.uppercase': 'This field must be a upper case string',
    'string.uri': 'This field must be a valid URI',
    'string.uriCustomScheme': 'This field must be a valid URI',
    'string.uriRelativeOnly': 'This field must be a valid relative URI',
    'symbol.base': 'This field is required',
    // 'symbol.map': '',
};

export default messages;
